module.exports = __webpack_public_path__ + "static/media/transaction.0486e146.svg";